import { Container } from "@mui/material";
import { apiGetProjects } from "api/projectApi";
import { apiGetProjectAccountCard } from "api/reportApi";
import FactorIcon from "assets/icons/FactorIcon";
import ReturnedFactorIcon from "assets/icons/ReturnedFactorIcon";
import Header from "components/CloseFiscalYear/Header";
import BasicDateInput from "components/BasicInputs/BasicDateInput";
import BasicSelect from "components/BasicInputs/BasicSelect";
import PageHeader from "components/Shared/PageHeader";
import { PriceCardContainer } from "components/Shared/report/PriceCardContainer";
import Table from "components/Table";
import useDateState from "helpers/useDateState";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/store";
import { setTableData } from "store/actions/dataTableAction";

export interface ProjectsAccountCardProps { }

interface FD {
  projectId?: number;
  tab?: string;
  profit: number;
  search?: any;
  sort?: any;
}

export default function ProjectsAccountCard(props: ProjectsAccountCardProps) {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { toDate, fromDate, setDates } = useDateState();
  const store = useAppSelector((x) => x);
  const { token } = store.businessReducer.business;
  const { projects } = store.projectReducer;
  const pagination = store.paginationReducer;
  const [formData, setFormData] = useState<FD>({
    profit: 0,
    projectId: parseInt(searchParams.get("projectId") || "0"),
  });
  const [project, setProject] = useState<any>({});
  const { projectId, search, sort, tab } = formData;
  let pr = { ...project };
  Object.keys(project).map((key) => {
    if (typeof project[key] === "number") {
      pr[key] = Math.abs(project[key]);
    }
  });

  const {
    totalAmountBuy,
    totalAmountBuyReturn,
    totalAmountCost,
    totalAmountIncome,
    totalAmountSale,
    totalAmountSaleReturn,
    totalAmountWaste,
    totalAmountDebtors,
    totalAmountCreditors,
    countBuy,
    countBuyReturn,
    countCreditors,
    countDebtors,
    countSale,
    countSaleReturn,
    countWaste,
  } = pr;

  /* -------------------------------------------------------------------------- */
  /*                                   PROFIT                                   */
  /* -------------------------------------------------------------------------- */
  const profit =
    totalAmountSale +
    -totalAmountBuy +
    totalAmountBuyReturn +
    -totalAmountSaleReturn +
    -totalAmountCost +
    totalAmountIncome +
    -totalAmountWaste +
    totalAmountCreditors +
    -totalAmountDebtors;
  /* ------------------------------- END PROFIT ------------------------------- */

  useEffect(() => {
    getProjectCard();
  }, [formData.projectId, fromDate]);

  useEffect(() => {
    submit();
  }, [tab, pagination]);

  async function getProjectCard() {
    let { search, sort } = pagination;
    if (projectId) {
      dispatch(
        apiGetProjectAccountCard({
          token,
          search,
          sort,
          options: Object.assign({ projectId }, fromDate ? { primarySearch: fromDate, secondarySearch: toDate, column: "date",filterType:'7',columnType:"date" } : {}),
          cb: (response: any) => {
            dispatch(setTableData([], undefined));

            const card = response?.data?.accountCard;
            setProject(card);
          },
        })
      );
    }
  }

  async function submit() {
    let { search, sort } = pagination;
    let params: any = Object.assign({ projectId, onlyTable: true }, fromDate ? { primarySearch: fromDate, secondarySearch: toDate, column: "date",filterType:'7',columnType:"date" } : {});
    dispatch(apiGetProjectAccountCard({ pagination, token, search, sort, options: params, tab }));
  }

  return (
    <Container maxWidth="xl" style={{ minHeight: "calc(100vh)" }}>
      <PageHeader heading="کارت پروژه" subHeading="ثبت کالا و خدمات جدید" />
      <div className="flex flex-wrap gap-4 my-10">
        <div style={{ width: 245 }}>
          <BasicDateInput
            range
            placeholder="کل سال مالی"
            onChange={(dates) => setDates(dates)}
            defaultValues={fromDate && toDate ? [fromDate, toDate] : undefined}
          />
        </div>
        <BasicSelect
          options={projects}
          placeholder="پروژه"
          defaultValue={projectId}
          onChange={(val) => setFormData((x) => ({ ...x, projectId: val }))}
          containerStyle={{ width: 245 }}
          withSearch
          withRefresh
          refreshList={() => dispatch(apiGetProjects(token))}
        />
      </div>
      {project && (
        <>
          <div style={{ backgroundColor: "#ffffff", borderRadius: "10px", marginBottom: 40 }}>
            <Header withDivider>
              <span style={{ fontSize: 22 }}>{project.title || "عنوان پروژه"}</span>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={{ fontSize: 16 }}> {profit === 0 ? "تراز" : profit > 0 ? "سود" : "زیان"}</span>
                <span style={{ fontSize: 20, color: `${profit < 0 ? "#CB0B0B" : "#1E8E1B"}` }}>
                  {profit ? Intl.NumberFormat().format(Math.abs(profit)) : 0}
                </span>
                <span style={{ fontSize: 14 }}>{"ريال"}</span>
              </div>
            </Header>

            <PriceCardContainer
              title="فاکتورها"
              prices={[
                {
                  label: "فروش",
                  price: totalAmountSale,
                  count: countSale,
                  icon: <FactorIcon color="#CB0B0B" />,
                },
                { label: "خرید", price: totalAmountBuy, count: countBuy, icon: <FactorIcon /> },
                {
                  label: "برگشت از فروش",
                  price: totalAmountSaleReturn,
                  count: countSaleReturn,
                  icon: <ReturnedFactorIcon color="#CB0B0B" />,
                },
                {
                  label: "برگشت از خرید",
                  price: totalAmountBuyReturn,
                  count: countBuyReturn,
                  icon: <ReturnedFactorIcon />,
                },
                {
                  label: "ضایعات",
                  price: totalAmountWaste,
                  count: countWaste,
                  icon: <FactorIcon color="#FDA4AF" />,
                },
              ]}
            />
            <PriceCardContainer
              title="حسابداری"
              prices={[
                { label: "هزینه", price: totalAmountCost, icon: <FactorIcon color="#CB0B0B" /> },
                { label: "درآمد", price: totalAmountIncome, icon: <FactorIcon /> },
                {
                  label: "بدهکاران",
                  price: totalAmountDebtors,
                  count: countDebtors,
                  icon: <ReturnedFactorIcon />,
                },
                {
                  label: "بستانکاران",
                  price: totalAmountCreditors,
                  count: countCreditors,
                  icon: <FactorIcon color="#FDA4AF" />,
                },
              ]}
            />
          </div>
          <Table
            type="projectAccountCard"
            onTabChange={(options) => setFormData((x) => ({ ...x, tab: options.activeTab.apiKey }))}
            onSearch={(options) => {
              setFormData((x) => ({ ...x, ...options }));
            }}
            style={{ margin: "0px 0px 40px 0px" }}
          />
        </>
      )}
    </Container>
  );
}
